export const fixNumber = (num, digits = 2) => {
	return +num.toFixed(digits)
}

export const rebuildTree = (children) => {
	if (!children || !children.length) return [];
	// FIXME REMOVE AccountNo & itemNo & comments
	// const tempChildren = children.reverse().sort((a, b) => (b.accountNo || b.itemNo) - (a.accountNo || a.itemNo));
	
	const tempChildren = children.sort((a, b) => {
		const aNo = +a.root.accountingNo || +a.root.itemNo;
		const bNo = +b.root.accountingNo || +b.root.itemNo;
		return aNo - bNo;
	});
	
	const tempTree = [];
	
	// children.forEach(child => {
	tempChildren.forEach(child => {
		tempTree.push({
			...child.root,
			children: rebuildTree(child.children)
		})
	});
	return tempTree;
}

export const getFlatTree = (tree, withParent = false) => {
	const items = [];
	for (let i = 0; i < tree.length; i++) {
		const item = tree[i];
		if (item.children && item.children.length) {
			if (withParent) items.push(item);
			items.push(...getFlatTree(item.children, withParent));
		} else {
			items.push(item);
		}
	}
	return items;
}

export const isEmptyId = (id) => {
	return id === '00000000-0000-0000-0000-000000000000'
}

export const toKiloGram = (quitsalAmount, useFixNumber = true) => {
	return useFixNumber ? fixNumber(quitsalAmount * 46) : quitsalAmount * 46;
}

export const toQuintal = (kgAmount, useFixNumber = true) => {
	return useFixNumber ? fixNumber(kgAmount / 46) : kgAmount / 46;
}